import { Box, Flex, Heading, Text } from 'core/components';
import { Field, InputGroup, Switch as FormSwitch } from 'core/form';
import Duration from 'core/form/components/Duration';
import React from 'react';
import { opacify } from 'polished';
import styled from 'styled-components';
import { observer } from 'mobx-react';

const HR = styled.hr`
  margin-top: 16px;
  margin-bottom: 16px;
  border-color: ${({ theme }) => opacify(0.18, theme.borderColors.thin)};
  border-style: solid;
  border-width: 1px 0 0;
`;

const PollingConfigSection = ({ form, isReadOnly, onUseSnmpPollingDefaultsChange }) => {
  const useSnmpPollingDefaults = form.getValue('uiProperties.polling.snmp.useDefaults');

  return (
    <>
      <HR />
      <Heading level={5} mb="4px">
        Polling options
      </Heading>
      <Text muted>Fine tune how SNMP polling is performed.</Text>
      <Flex mt={2} flexDirection="column" gap={2}>
        <Field
          name="uiProperties.polling.snmp.useDefaults"
          large
          onChange={onUseSnmpPollingDefaultsChange}
          disabled={isReadOnly}
        >
          <FormSwitch switchLabel="Use NMS defaults" />
        </Field>
        <Flex gap={1}>
          <Box flex="1">
            <Field
              name="settings.polling.snmp.max-oids"
              component={InputGroup}
              large
              disabled={isReadOnly || useSnmpPollingDefaults}
            />
          </Box>
          <Box flex="1">
            <Field
              name="settings.polling.snmp.max-repetitions"
              component={InputGroup}
              large
              disabled={isReadOnly || useSnmpPollingDefaults}
            />
          </Box>
        </Flex>
        <Flex gap={1}>
          <Field name="settings.polling.snmp.timeout" large disabled={isReadOnly || useSnmpPollingDefaults}>
            <Duration flex="1" width={undefined} />
          </Field>
          <Box flex="1">
            <Field
              name="settings.polling.snmp.retries"
              component={InputGroup}
              large
              disabled={isReadOnly || useSnmpPollingDefaults}
            />
          </Box>
          <Box flex="1">
            <Field
              name="settings.polling.snmp.workers"
              component={InputGroup}
              large
              disabled={isReadOnly || useSnmpPollingDefaults}
            />
          </Box>
        </Flex>
      </Flex>
    </>
  );
};

export default observer(PollingConfigSection);
